import { memo } from "react";

import { Block, Divider, SvgIcon, Touchable, Typography, palette } from "@stepapp/ui";

type Props = {
  latitude?: number | null;
  longitude?: number | null;
  city?: string | null;
  postalCode?: string | null;
  onPress: () => void;
  address?: string | null;
  country?: string | null;
  divider?: boolean;
};

function AutocompleteItemComponent({
  divider,
  onPress,
  city,
  postalCode,
  address,
  country,
}: Props) {
  return (
    <>
      <Touchable onPress={onPress}>
        <Block alignCenter row paddingVertical={1.5}>
          <Block paddingRight={1}>
            <SvgIcon color={palette.primary.accent} name="pin" />
          </Block>

          <Block flex={1}>
            <Typography variant="bodyBold">{address}</Typography>
            <Typography type="secondary">
              {postalCode} {city}, {country}
            </Typography>
          </Block>
        </Block>
      </Touchable>

      {divider && <Divider spaceless color={palette.secondary.grey} />}
    </>
  );
}

export const AutocompleteItem = memo(AutocompleteItemComponent);
